import { gql } from "apollo-angular";

const getProyectos = gql`
  query Projects($args: FilterParamsInput) {
    projects(args: $args) {
      id
      code
      name
      description
      weighing
      allocationId
      question {
        id
      }
      adicionales {
        id
        projectId
        nombre
        orden
        tipo
        createdAt
        updatedAt
        deletedAt
        createdBy
      }
      responsible {
        id
        name
        last_name
        last_name2
        email
        role_name
        institution_id
      }
    }
  }
`;

const getOnlyProjects = gql`
  query Projects($args: FilterParamsInput) {
    projects(args: $args) {
      code
      description
      id
      name
      question {
        id
      }
      weighing
    }
  }
`;

const getActivities = gql`
  query Activities($args: FilterParamsInput) {
    activities(args: $args) {
      code
      due_date
      id
      name
      progress {
        id
        month
        year
        planned
        executed
      }
      start_date
      adicionales {
        id
        nombre
        tipo
        monto
        comentarios {
          id
          actividadAdicitionalId
          comentario
          date
        }
        archivos {
          id
          actividadAdicitionalId
          nombre
          date
          s3key
          type
        }
      }
      responsible {
        id
        name
        last_name
        last_name2
        email
        role_name
        institution_id
      }
    }
  }
`;

const getAdicionales = gql`
  query Query($projectId: String!) {
    aditionalsByProject(projectId: $projectId) {
      id
      projectId
      nombre
      orden
      tipo
      createdAt
      updatedAt
      deletedAt
      createdBy
    }
  }
`;

const getFiles= gql`
  query Query($s3Key: String!) {
    getFilePresignedUrl(s3Key: $s3Key)
  } 
`

const getResponsables = gql`
  query Query($institutionId: String!) {
    rolesByInstitution(institution_id: $institutionId) {
      id
      name
      last_name
      last_name2
      email
      role_name
      institution_id
    }
  }
`;

export { 
  getProyectos,
  getOnlyProjects,
  getActivities,
  getAdicionales,
  getResponsables,
  getFiles,
}